import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useUpdateAccessRole from "hooks/Auth/role/useUpdateAccessRole";

interface AuthRoleUpdaterProps {
  children: React.ReactNode;
}

export const AuthRoleUpdater: React.FC<AuthRoleUpdaterProps> = ({
  children,
}) => {
  const location = useLocation();
  const { updateAccessRole } = useUpdateAccessRole();
  const [initialized, setInitialized] = useState(false);

  // 초기 권한 세팅
  useEffect(() => {
    const initialize = async () => {
      try {
        await updateAccessRole();
      } finally {
        setInitialized(true);
      }
    };
    initialize();
  }, []);

  // 라우트 변경시 권한 업데이트
  useEffect(() => {
    if (!initialized) return;

    updateAccessRole();
  }, [location.pathname, initialized]);

  // 초기 로딩 중에는 아무것도 표시하지 않음
  if (!initialized) {
    return null;
  }

  return <>{children}</>;
};
